import { requestApi } from '../../../../services/api.js';
import {
	VerifyIdentifierResponse,
	VerifyCodeResponse,
	UpdatePasswordResponse,
	ChangePWLoginResponse,
	UpdateStatusResponse,
	ReopenAccountResponse
} from './response.types';
import {
	ReopenAccountPayload,
	VerifyPayload,
	UpdatePasswordPayload,
	VerifyCodePayload,
	UpdateStatusPayload
} from './payload.types';

const API_BASE_PATH = process.env.API_BASE_PATH || '';

const BASE_URL = `${API_BASE_PATH}/resetpw`;

export const verifyIdentifier = (captchaToken: string, payload: VerifyPayload): VerifyIdentifierResponse => {
	return requestApi(`${BASE_URL}/send`, payload, 'POST', false, false, {
		'Captcha-Token': captchaToken
	}) as VerifyIdentifierResponse;
};

export const preSend = (payload: VerifyPayload): VerifyIdentifierResponse => {
	return requestApi(`${BASE_URL}/preSend`, payload, 'POST') as VerifyIdentifierResponse;
};

export const verifyCode = (code: string, payload: VerifyCodePayload): VerifyCodeResponse => {
	return requestApi(`${BASE_URL}/${code}/verify`, payload, 'POST') as VerifyCodeResponse;
};

export const updatePassword = (code: string, payload: UpdatePasswordPayload): UpdatePasswordResponse => {
	return requestApi(`${BASE_URL}/${code}/update`, payload, 'POST') as UpdatePasswordResponse;
};

export const changePWLogin = (code: string, payload: VerifyCodePayload): ChangePWLoginResponse => {
	return requestApi(`${BASE_URL}/${code}/login`, payload, 'POST') as ChangePWLoginResponse;
};

export const updateStatus = (payload: UpdateStatusPayload): UpdateStatusResponse => {
	return requestApi(`${BASE_URL}/updateStatus`, payload, 'POST') as UpdateStatusResponse;
};

export const reopenAccountCall = (payload: ReopenAccountPayload) => {
	return requestApi(`${BASE_URL}/updateStatus`, payload, 'POST') as ReopenAccountResponse;
};
